import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_rectangle = _resolveComponent("l-rectangle")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_circle_marker = _resolveComponent("l-circle-marker")!
  const _component_l_feature_group = _resolveComponent("l-feature-group")!

  return (_openBlock(), _createBlock(_component_l_feature_group, null, {
    default: _withCtx(() => [
      _createVNode(_component_l_rectangle, {
        "fill-color": _ctx.color,
        "fill-opacity": 0.25,
        color: _ctx.color,
        weight: 2,
        bounds: _ctx.rectangleBounds,
        interactive: false
      }, null, 8, ["fill-color", "color", "bounds"]),
      _createVNode(_component_l_circle_marker, {
        "lat-lng": _ctx.endRef,
        stroke: false,
        fill: false,
        interactive: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_l_tooltip, {
            options: {
          permanent: true,
          direction: _ctx.tooltipPosition,
          offset: _ctx.tooltipOffset,
        }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, _toDisplayString(_ctx.rectangleSize), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.numOfAffectedStationsTooltip), 1)
              ])
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 8, ["lat-lng"])
    ]),
    _: 1
  }))
}